// src/pages/manufacturing.js
import React, { useState } from "react";
import { useNavigate} from "react-router-dom";
import "./manufacturing.css";
import Footer from "../components/Footer";

import Button from "react-bootstrap/Button";

import Navbar from "../components/Navbar";

import Icon1 from "../assets/Industry/Connected.png"
import Icon2 from "../assets/Industry/NotificationCenter.png"
import Icon3 from "../assets/Industry/Tracking.png"
import Icon4 from "../assets/Industry/Decline.png"

const Manufacturing = () => {
  const [activeTab, setActiveTab] = useState("resourceTracking");
  const navigate = useNavigate()
  const content = {
    resourceTracking: {
      title: "Track every material, every move — seamlessly and in real time.",
      description: [
        "Monitor real-time movement across all locations.",
        "Track incoming and outgoing material with ease.",
        "Get instant updates on material status shifts.",
      ],
      image: "100001548.jpeg",
    },
    riskManagement: {
      title: "Workplace Safety & Risk Management",
      description: [
        "Real-time hazard detection like missing PPE.",
        "Monitor worker activity to prevent accidents.",
        "Track safety compliance automatically.",
      ],
      image: "manufacturing 4.jpg",
    },
    smartAutomation: {
      title: "SMART AUTOMATION FOR PRODUCTIVITY",
      description: [
        "Detects defects instatntly with automated quality checks.",
        "Optimize workflow and reduce bottlenecks.",
        "Get alerts for predictive maintenance before breakdowns.",
      ],
      image: "manufacturing 3.jpg", // Replaced with image
    },
    dataDrivenInsights: {
      title: "DATA DRIVEN INSIGHTS & REMOTE MONITORING",
      description: [
        "Visualize live production data instantly.",
        "Optimize processes with actionable insights",
        "Remote factory monitoring anytime,anywhere.",
      ],
      image: "manufacturing 2.jpg",
    },
  };

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>
      {/* Manufacturing Section */}

      <div className="container-mirrored">
        <div className="image-section-mirrored">
          <img src="Manufacturing 1.png" alt="Product Line" />
        </div>
        <div className="content-mirrored">
          <h1>
            <span className="line">Smarter systems, </span>
            <span className="line">Smoother Flow </span>
          </h1>
          <h4 style={{ fontWeight: "300" }}>
            With smart insights doing the heavy lifting, you can fine-tune, fix,
            and speed things up—without breaking a sweat.
          </h4>
          <Button
          
            // href="https://forms.gle/P7B2NMVwGstAeVea8"
            onClick={()=>{navigate("/Demo")}}
            className="know-more-btn"
          >
            Get Started
          </Button>
        </div>
      </div>

      <div className="centered-section">
        <h2>
          Want to see what smart really looks
          <br />
          like on the floor?
        </h2>
        <h6>
          Empower your production floor with intelligent safety measures and
          seamless automation that drive performance.
        </h6>
        
      </div>

      <div className="app2">
        <div className="tabs2">
          {Object.keys(content).map((tabKey) => (
            <button
              key={tabKey}
              className={`tab2 ${activeTab === tabKey ? "active2" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {content[tabKey].title.split(" & ")[0]}
            </button>
          ))}
        </div>

        <div className="content2">
          <div className="text-column2">
            <h2>{content[activeTab].title}</h2>
            <hr />
            <p>
              {content[activeTab].description.map((desc, index) => (
                <div key={index}>• {desc}</div>
              ))}
            </p>
          </div>
          <div className="image-column2">
            <img
              src={content[activeTab].image}
              alt={content[activeTab].title}
            />
          </div>
        </div>
      </div>

      <div className="app-container2">
        <header className="app-header2">
          <h1 className="title2">Industry Insights by the Numbers</h1>
        </header>

        <div className="statistics-container2">
          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+20%</h2>
            <p className="statistic-description21">Overall Productivity</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Through Automation</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-50%</h2>
            <p className="statistic-description21">Defect Rate</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              With Quality Control System
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+15%</h2>
            <p className="statistic-description21">
              Overall Equipment Effectiveness
            </p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              With Predictive Maintenance
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-30%</h2>
            <p className="statistic-description21">Lead Time Reduction</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Through Streamline Process</p>
          </div>
        </div>
      </div>

      <div className="app-container3">
        <div className="content3" style={{ textAlign: "left" }}>
          <h1 className="title3">
            Optimize Manufacturing Efficiency with Argus
          </h1>
          <Button
            onClick={()=>{navigate('/contact')}}
            className="connect-button3"
          >
            Connect Now
          </Button>
        </div>

        <div className="card-container3">
          <div className="card3">
            <div className="icon3">
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Seamless Integration into your Production System
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Real-Time Alert for Proactive Management
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Comprehensive Traceability to ensure High Quality
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon4} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Operational Excellence with reduced downtime
            </h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Manufacturing;
